import { BaseModel } from "../../../core/models";
import { type GroupLensConnection } from "../../../../gql-generated/types";

export class GroupsGridLensModel {
    readonly iconUrl: string | null = null;
    readonly compId: string | null = null;
    readonly name: string | null = null;
    readonly id: string | null = null;
    readonly priority: number | null = null;
    readonly lensSource: string | null = null;

    static createFromGroupLensConnection({ lens, priority }: GroupLensConnection): GroupsGridLensModel {
        const { iconUrl, compoundId, name, lensSourceInfo } = lens!;
        const lensSource = lensSourceInfo?.name ?? "";
        return BaseModel.createInstance(GroupsGridLensModel, {
            iconUrl,
            compId: `${compoundId?.id}+${compoundId?.reference}-GroupLens`,
            name,
            id: compoundId?.id,
            priority,
            lensSource,
        });
    }
}
